import {createAction} from "redux-actions";
import {query} from "../../utilities/query";

export const deactivateSigntask = Object.assign(
  (id, deactivate, archive) => dispatch => dispatch(query(deactivateSigntask)(`/api/signtask/${id}`, "PATCH", { deactivate: deactivate, archive: archive })),
  {
    success: createAction("signtasks/DEACTIVATE_SUCCESS", signtask => ({[signtask.id]: signtask})),
    failure: createAction("signtasks/DEACTIVATE_FAILURE")
  }
);